import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

/**
 * Exports data to an Excel file using exceljs and file-saver.
 * @param {Array} data - Array of objects to be exported.
 * @param {String} fileName - Name of the file to be saved.
 * @param {String} sheetName - Name of the sheet in the Excel file.
 * @param {Function} styleRowFn - Optional callback to style specific rows.
 */
export const downloadExcel = async (
  data,
  fileName = "DataExport",
  sheetName = "Sheet1",
  styleRowFn = null,
) => {
  if (!data || data.length === 0) {
    console.error("No data to export");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(sheetName);

  // Get headers, but IGNORE keys that start with "_" (hidden keys for logic)
  const headers = Object.keys(data[0]).filter((key) => !key.startsWith("_"));

  worksheet.columns = headers.map((header) => ({
    header: header,
    key: header,
    width: 20,
  }));

  // Add rows one by one so we can style them
  data.forEach((rowData) => {
    const row = worksheet.addRow(rowData);

    // If a styling function was provided, run it for this row
    if (styleRowFn) {
      styleRowFn(row, rowData);
    }
  });

  // Style the header row
  worksheet.getRow(1).font = { bold: true };

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${fileName}.xlsx`);
};
